import { initializeApp, deleteApp } from 'firebase/app';
import { getAuth, createUserWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { firebaseConfig } from '../firebaseDDH';
import { recordClient } from './clients';

function throwawayPassword() {
  const bytes = crypto.getRandomValues(new Uint8Array(24));
  return Array.from(bytes, (b) => b.toString(36).padStart(2, '0')).join('');
}

// Creates the account on a secondary, disposable Firebase app instance so the
// admin's own signed-in session is never swapped out for the new user's.
export async function createAccountForEmail(email, name = null) {
  const secondaryApp = initializeApp(firebaseConfig, `admin-create-${Date.now()}`);
  const secondaryAuth = getAuth(secondaryApp);
  try {
    await createUserWithEmailAndPassword(secondaryAuth, email, throwawayPassword());
    await sendPasswordResetEmail(secondaryAuth, email);
    // Written through the primary app, i.e. as the signed-in admin, since the
    // clients collection is admin-only. Auth can't be listed from the client
    // SDK, so this mirror is what the quote form's dropdown reads.
    await recordClient(email, name);
  } finally {
    await deleteApp(secondaryApp);
  }
}
